import { faSquareArrowUpRight } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@repo/videa-components';

import { PerioChart } from '@/common-components/composed/PerioChart/PerioChart';
import type { PerioChartResponse } from '@/common-components/composed/PerioChart/types';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import { IconPill } from './IconPill';
import { StageIconPill } from './StageIconPill';

interface Props {
  perioChartData: PerioChartResponse;
  stage?: number;
}

export const PerioChartDialog = ({ perioChartData, stage }: Props) => {
  const { trackEvent } = useTrackEvent();
  const { t } = useLingui();

  return (
    <Dialog>
      <DialogTrigger
        className="vai-flex vai-justify-center vai-items-center"
        onClick={() => {
          trackEvent(mixpanelEvents.perioChartButtonClick, {
            examDate: perioChartData.examDate,
            toothCount: perioChartData.teeth.length,
          });
        }}
      >
        <IconPill
          text={t`Perio Chart`}
          icon={
            <FontAwesomeIcon
              className="vai-text-zinc-50"
              icon={faSquareArrowUpRight}
              size="xs"
            />
          }
        />
      </DialogTrigger>
      <DialogContent className="vai-bg-zinc-950 vai-border-zinc-600 vai-text-zinc-50 !vai-w-[90%] vai-h-[90vh] !vai-flex !vai-flex-col vai-overflow-hidden">
        <DialogHeader className="vai-flex-shrink-0">
          <DialogTitle className="vai-mb-1 vai-flex vai-items-center vai-gap-8">
            <Trans>Periodontal Data Chart</Trans>
            {!!stage && <StageIconPill stage={stage} />}
          </DialogTitle>
        </DialogHeader>

        <div
          style={{
            scrollbarWidth: 'thin',
            scrollbarColor: '#52525b transparent',
          }}
          className="vai-flex-1 vai-overflow-auto vai-min-h-0"
        >
          <div className="vai-w-fit vai-mx-auto vai-pl-[5%] vai-pr-[5%]">
            <PerioChart mode="dark" perioChartData={perioChartData} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
